// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cartDropdownEmpty{padding:1.5rem 1.5rem 0}.cartDropdownEmpty__title{border-bottom:1px solid #e6e6e6;font-size:1.5rem;font-weight:700;line-height:1.9rem;padding-bottom:1.5rem}.cartDropdownEmpty__inner{margin-bottom:5rem;margin-top:2.5rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
